export enum ExpertBookingLocationType {
	Remote,
	OnLocation,
}
